/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { normalizeMember } from 'app/gamma/src/api/normalizers/member';
// eslint-disable-next-line no-restricted-imports
import type { LoadBoardSuccessAction } from 'app/gamma/src/modules/loaders/load-board';
// eslint-disable-next-line no-restricted-imports
import { LOAD_BOARD_SUCCESS } from 'app/gamma/src/modules/loaders/load-board';
// eslint-disable-next-line no-restricted-imports
import type { LoadHeaderSuccessAction } from 'app/gamma/src/modules/loaders/load-header';
// eslint-disable-next-line no-restricted-imports
import { LOAD_HEADER_SUCCESS } from 'app/gamma/src/modules/loaders/load-header';
import type { LoadMyBoardsSuccessAction } from 'app/src/components/ReduxSearch/loadBoardsForSearch';
import { LOAD_MY_BOARDS_SUCCESS } from 'app/src/components/ReduxSearch/loadBoardsForSearch';
// eslint-disable-next-line no-restricted-imports
import type { LoadMemberSuccessAction } from 'app/gamma/src/modules/loaders/load-member';
// eslint-disable-next-line no-restricted-imports
import { LOAD_MEMBER_SUCCESS } from 'app/gamma/src/modules/loaders/load-member';
// eslint-disable-next-line no-restricted-imports
import type {
  SocketMemberAction,
  SocketDropNonPublic,
} from 'app/gamma/src/modules/sockets';
// eslint-disable-next-line no-restricted-imports
import {
  isDeletedModel,
  SOCKET_MEMBER,
  SOCKET_DROP_NON_PUBLIC,
} from 'app/gamma/src/modules/sockets';
// eslint-disable-next-line no-restricted-imports
import type { MemberResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import type { MemberModel } from 'app/gamma/src/types/models';
// eslint-disable-next-line no-restricted-imports
import { createReducer } from '@trello/redux';
import type {
  GetSearchSuggestionsAction,
  PerformSearchSuccessAction,
} from 'app/src/components/ReduxSearch/search-actions';
import {
  PERFORM_SEARCH_SUCCESS,
  SET_SEARCHED_SUGGESTIONS,
} from 'app/src/components/ReduxSearch/search-actions';

// Reducer
export interface MemberState {
  [memberId: string]: MemberModel;
}

const initialState: MemberState = {};
const upsertMember = (state: MemberState, member: MemberResponse) => {
  return {
    ...state,
    [member.id]: normalizeMember(member, state[member.id]),
  };
};

export default createReducer(initialState, {
  [LOAD_BOARD_SUCCESS](
    state: MemberState,
    { payload }: LoadBoardSuccessAction,
  ) {
    const { members = [] } = payload;

    return members.reduce(
      (result, member) => upsertMember(result, member),
      state,
    );
  },

  [LOAD_MY_BOARDS_SUCCESS](
    state: MemberState,
    { payload }: LoadMyBoardsSuccessAction,
  ) {
    return upsertMember(state, payload);
  },

  [LOAD_HEADER_SUCCESS](
    state: MemberState,
    { payload }: LoadHeaderSuccessAction,
  ) {
    return upsertMember(state, payload);
  },

  [PERFORM_SEARCH_SUCCESS](
    state: MemberState,
    { payload }: PerformSearchSuccessAction,
  ) {
    const { members = [], cards = [] } = payload;
    const cardMembers = cards.reduce((result, card) => {
      return result.concat(card.members ? card.members : []);
    }, [] as MemberResponse[]);

    return members
      .concat(cardMembers)
      .reduce((result, m) => upsertMember(result, m), state);
  },

  [SET_SEARCHED_SUGGESTIONS](
    state: MemberState,
    { payload }: GetSearchSuggestionsAction,
  ) {
    const { members = [], cards = [] } = payload;
    const cardMembers = cards.reduce((result, card) => {
      return result.concat(card.members ? card.members : []);
    }, [] as MemberResponse[]);

    return members
      .concat(cardMembers)
      .reduce((result, m) => upsertMember(result, m), state);
  },

  [SOCKET_DROP_NON_PUBLIC](
    state: MemberState,
    { payload: memberId }: SocketDropNonPublic,
  ) {
    return {
      ...state,
      [memberId]: {
        ...state[memberId],
        nonPublic: {},
      },
    };
  },

  [SOCKET_MEMBER](state: MemberState, { payload }: SocketMemberAction) {
    if (isDeletedModel(payload)) {
      const { [payload.id]: removed, ...remaining } = state;

      return remaining;
    }
    return upsertMember(state, payload);
  },

  [LOAD_MEMBER_SUCCESS](
    state: MemberState,
    { payload }: LoadMemberSuccessAction,
  ) {
    return upsertMember(state, payload);
  },
});
